import LocationService from '../../../services/LocationService/LocationService';
import { getDataFromUrlParams, getProductList, getSmartPhrases, setDataFilter } from '../../location';
import { MainStore } from '../../store';
import { setError, setLoader } from '../../ui';

export const INIT = '[INIT]';

const initHandler = (store: MainStore): void => {
    store.dispatch(setLoader({ filter: true }));
    const bookingYear = store.getState().location.bookingYear;

    store.dispatch(getSmartPhrases());
    console.debug('initHandler called');

    LocationService.getProductFilter({ bookingyear: bookingYear })
        .then(data => store.dispatch(setDataFilter(data.data)))
        .then(() => {
            store.dispatch(getDataFromUrlParams());
        })
        .then(() => {
            store.dispatch(getProductList({ bookingyear: bookingYear, reset: true }));
        })
        .catch(err => store.dispatch(setError({ filter: err })))
        .finally(() => store.dispatch(setLoader({ filter: false })));
};

const initHandlers = {
    [INIT]: initHandler,
};

export default initHandlers;
